import type { UnitCircleWidgetConfig } from '../unit-circle.model';

/** Special angles displayed in degrees instead of radians. */
export const UNIT_CIRCLE_SPECIAL_ANGLES_DEG_PRESET: UnitCircleWidgetConfig = {
  id: 'unit-circle-special-angles-deg',
  type: 'unit-circle',
  params: {
    angleUnit: 'deg',
    point: { angle: '\\pi/4', snap: 'attract' },
    specialAngles: { showAngles: true, showCoords: true },
    quadrants: { labels: true, signIndicators: true },
  },
  display: {
    coordinateSystem: {
      boundingbox: { xStart: -2, xEnd: 2, yStart: -2, yEnd: 2 },
      grid: { type: 'lines', visible: true },
    },
  },
};
